/**
 * Search page.
 */
import Search from '../templates/search';

export default function SearchPage() {
  return <Search />;
}
